import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, FormControl, FormHelperText, InputAdornment, Stack } from "@mui/material"
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import MaterialBox from "../../../components/MaterialBox";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import { allDepartmentQuery, allDesignationQuery, allSalaryStructuresQuery, getOnboardLetterByIdQuery, submitOnboardLetterQuery, updateOnboardLetterQuery } from "./Queries";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";
import Swal from "sweetalert2";

const AppointmentLetterForm = () => {

    const navigate = useNavigate();    
    const [searchParams] = useSearchParams();

    const mode = searchParams.get("mode");
    const id = searchParams.get("id");
    const [togglePage, setTogglePage] = useState({
        view: false,
        edit: false,
    });
    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: mode ||"init",
    });
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [salaryStructureOptions, setSalaryStructureOptions] = useState([]);
    const [formData, setFormData] = useState({
        fullName: "",
        emp_id: "",
        department: "",
        designation: "",
        endTime: "",
        doj: "",
        ctc: "",
        salaryStructureId: "",
        basicPercentage: ""
    });

    useEffect(() => {
        if(mode === 'view'){
            setTogglePage({...togglePage, view: true, edit: false})

        }
        else if(mode === 'edit'){
            setTogglePage({...togglePage, edit: true, view: false})
        }
        if ((mode === "edit" || mode === "view") && id) {
            getEmployeeOnboardLetterById(id);
        }
    }, [mode, id]);


    useEffect(() => {
        if(togglePage.view === true || mode === "view") return;

        allDepartmentApi();
        onDesignationDropdown();
        allSalaryStructureApi();
    },[togglePage]);

    const getEmployeeOnboardLetterById = async (id) => {
        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: getOnboardLetterByIdQuery,
                    variables: {
                        id: id,
                    },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result = response.data?.data?.employeeOnboardLetterById;

            if (result?.success) {
                const data = result?.data;

                setFormData({
                    id: data?.id || "",
                    emp_id: data?.empId || '',
                    emp_idStatus: data?.empId ? "success" : "unchecked",
                    fullName: data?.fullName || "",
                    fullNameStatus: data?.fullName ? "success" : "unchecked",

                    department: data?.department
                        ? {
                            label: data.department,
                            value: data.department,
                        }
                        : "",
                    departmentStatus: data?.department
                        ? "success"
                        : "unchecked",

                    designation: data?.designation ? {
                            label: data.designation,
                            value: data.designation,
                        } : "",
                    designationStatus: data?.designation
                        ? "success"
                        : "unchecked",

                    doj: data?.doj || "",
                    dojStatus: data?.doj ? "success" : "unchecked",

                    ctc: data?.ctc || "",
                    ctcStatus:
                        data?.ctc !== null && data?.ctc !== undefined
                            ? "success"
                            : "unchecked",

                    salaryStructureId: data?.salaryStructure
                        ? {
                            label: data.salaryStructure.structureName,
                            value: data.salaryStructure.id,
                            type: data?.salaryStructure?.salaryType
                        }
                        : "",
                    salaryStructureIdStatus: data?.salaryStructure
                        ? "success"
                        : "unchecked",

                    basicPercentage: data?.basicPercentage || "",
                    basicPercentageStatus:
                        data?.basicPercentage !== null &&
                        data?.basicPercentage !== undefined
                            ? "success"
                            : "unchecked",
                });

                return data;
            } else {
                console.error(
                    "Failed to fetch Appointment letter:",
                    result?.message
                );

                Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                        result?.message ||
                        "Failed to fetch Appointment letter",
                    showConfirmButton: false,
                    timer: 2500,
                });

                return null;
            }
        } catch (error) {
            console.error(
                "Error fetching employee Appointment letter:",
                error
            );

            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    error?.response?.data?.errors?.[0]?.message ||
                    error?.message ||
                    "Failed to fetch Appointment letter",
                showConfirmButton: false,
                timer: 2500,
            });

            return null;
        }
    };

    const allDepartmentApi = async () => {
    
        try {
          setPageState({ ...pageState, loading: true });
    
          const response = await axios.post(
            BASEURL,
            {
              query: allDepartmentQuery,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
    
          // Extract department data from the response
          const departmentListdata = response.data.data.allDepartment;
          // setCirleLoading(false)
          setDepartmentOptions(departmentListdata);
          setPageState({ ...pageState, loading: false, state: "success" });
        } catch (error) {
          // setCirleLoading(false)
          console.error("ResponseError:", error);
          setPageState({
            ...pageState,
            loading: false,
            error: true,
            message: error.message,
          });
        }
    };

    const onDesignationDropdown = async () => {
        try {
        setPageState({ ...pageState, loading: true });
        const response = await axios.post(
            BASEURL,
            {
            query: allDesignationQuery,
            },
            {
            headers: {
                "Content-Type": "application/json",
            },
            },
        );

        const designationListdata = response.data.data.allDesignation;
        setDesignationOptions(designationListdata);
        setPageState({ ...pageState, loading: false, state: "success" });
        } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
            ...pageState,
            loading: false,
            error: true,
            message: error.message,
        });
        }
    };

    const allSalaryStructureApi = async () => {

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: allSalaryStructuresQuery
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });            

            // Extract Employee data from the response
            const salaryStructureList = response.data.data.salaryStructures;

            setSalaryStructureOptions(salaryStructureList);
            setPageState({ ...pageState, loading: false, state: 'success' });
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };
    
    const onSubmitForm = async () => {
        const variables = {
            full_name: formData.fullName,
            emp_id: formData?.emp_id,
            department: formData.department?.label,
            designation: formData.designation?.label,
            doj: formData.doj,
            ctc: Number(formData.ctc),
            salary_structure_id: formData.salaryStructureId?.value,
            basic_percentage: Number(formData.basicPercentage),
        };
        if(togglePage?.edit){
            try {
                const updateVariables = {
                    id: formData.id,
                    ...variables,
                };

                const response = await axios.post(
                    BASEURL,
                    {
                        query: updateOnboardLetterQuery,
                        variables: updateVariables,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result =
                    response.data?.data?.updateEmployeeOnboardLetter;

                if (result?.success) {
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title:
                            result?.message ||
                            "Updated Appointment Letter Successfully",
                        showConfirmButton: false,
                        timer: 2500,
                    });

                    navigate("/appointment-letter");
                } else {

                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title:
                            result?.message ||
                            "Failed to update Appointment letter",
                        showConfirmButton: false,
                        timer: 2500,
                    });
                }
            } catch (error) {

                Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                        error?.response?.data?.errors?.[0]?.message ||
                        error?.message ||
                        "Failed to update Appointment letter",
                    showConfirmButton: false,
                    timer: 2500,
                });
            }
        }else{
            try {    
                const response = await axios.post(
                    BASEURL,
                    {
                        query: submitOnboardLetterQuery,
                        variables: variables,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );
    
                const result = response.data?.data?.createEmployeeOnboardLetter;
                
                if (result?.success) {                    
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: result?.message || "Created Appointment Letter Successfully",
                        showConfirmButton: false,
                        timer: 2500,
                    });
                    navigate('/appointment-letter');
    
                } else {                    
    
                }
            } catch (error) {
                console.error("Error creating employee Appointment letter:", error);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                        error?.response?.data?.errors?.[0]?.message ||
                        error?.message ||
                        "Failed to fetch employee salaries",
                    showConfirmButton: false,
                    timer: 2500,
                });
            }            
        }
    };


    const checkAllFields = () => {
        let allowSubmit = false;
        if (
            formData.fullNameStatus === "success" &&
            formData.emp_idStatus === "success" &&
            formData.departmentStatus === "success" &&
            formData.designationStatus === "success" &&
            formData.dojStatus === "success" &&
            formData.ctcStatus === "success" &&
            formData.salaryStructureIdStatus === "success" &&
            formData.basicPercentageStatus === "success"
        ) {
            allowSubmit = true;
        } else {
            allowSubmit = false;
        }
        return allowSubmit;
    };

    const handleChange = (event,selectEvent) => {
        
        let formState ={...formData};

        //Dropdown Select
        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "salaryStructureId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (event && alphaNLenghthRegex.test(event?.trim?.())) {
                        formState[selectEvent.name + "Status"] = "success";
                    } else {
                        formState[selectEvent.name + "Status"] =
                            event === "" ? "unchecked" : "error";
                    }
                    if (event?.type === "TYPE_TWO") {
                        formState.basicPercentage = 0;
                        formState.basicPercentageStatus = "success";
                    }
                    else if (event?.type === "TYPE_ONE") {
                        formState.basicPercentage = 0;
                        formState.basicPercentageStatus = "success";
                    }

                    break;
                }


                case "department": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (event && alphaNLenghthRegex.test(event?.trim?.())) {
                        formState[selectEvent.name + "Status"] = "success";
                    } else {
                        formState[selectEvent.name + "Status"] =
                            event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }

        //Input field
        else if(event && event.target){
            switch(event.target.name){

                case "fullName": {
                    const alphaNLenghthRegex = new RegExp("^([a-zA-Z\\s]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                        formState[event.target.name + "Status"] = "success";
                    } else {
                        formState[event.target.name + "Status"] =
                            event.target.value === "" ? "unchecked" : "error";
                    }

                    break;
                }  

                case "emp_id": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,20})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                        formState[event.target.name + "Status"] = "success";
                    } else {
                        formState[event.target.name + "Status"] =
                            event.target.value === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "doj": {
                    if (event.target.value !== "") {
                        formState[event.target.name + "Status"] = "success";
                    } else {
                        formState[event.target.name + "Status"] = "unchecked";
                    }

                    break;
                }

                case "ctc": {
                    const ctcRegex = new RegExp("^\\d+(\\.\\d{1,2})?$");

                    if (ctcRegex.test(event.target.value) && Number(event.target.value) >= 0) {
                        formState[event.target.name + "Status"] = "success";
                    } else {
                        formState[event.target.name + "Status"] =
                            event.target.value === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "basicPercentage": {
                    const percentageRegex = new RegExp("^\\d+(\\.\\d{1,2})?$");

                    if (
                        percentageRegex.test(event.target.value) &&
                        Number(event.target.value) >= 0 &&
                        Number(event.target.value) <= 100
                    ) {
                        formState[event.target.name + "Status"] = "success";
                    } else {
                        formState[event.target.name + "Status"] =
                            event.target.value === "" ? "unchecked" : "error";
                    }

                    break;
                }

                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                        event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }

            formState[event.target.name] = event.target.value;
        }

        setFormData(formState);

    }


  return (
    <DashboardLayout>
        <Card>
            <CardHeader
            title={
                <>
                {togglePage.view === true || togglePage.edit === true ? (
                    <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1.5}
                        >
                            <ArrowBack sx={{cursor: "pointer"}} onClick={() => navigate("/appointment-letter")} />

                            <Stack direction="column" spacing={0}>
                                <MaterialTypography
                                    variant="h5"
                                    fontWeight="medium"
                                >
                                    {togglePage.view === true
                                        ? "View Appointment Letter Details"
                                        : "Edit Appointment Letter Details"}
                                </MaterialTypography>

                                <MaterialTypography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    {togglePage.view === true
                                        ? "Review the appointment letter details and information provided for this employee."
                                        : "Update the appointment letter details and make any necessary changes."}
                                </MaterialTypography>
                            </Stack>
                        </Stack>              
                    </Stack>
                ) : (
                    <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <ArrowBack sx={{cursor: "pointer"}} onClick={() => navigate('/appointment-letter')}/>
                        <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                            Add Appointment Letter Details
                        </MaterialTypography>
                        <MaterialTypography variant="caption" color="textSecondary">
                            Create the appointment letter details by providing information about the Employee.    
                        </MaterialTypography>
                        </Stack>
                    </Stack>
                    </Stack>
                )}
                </>
            }
            />
            <CardContent
            sx={{
                minHeight: pageState.state === "submitting" ? "65vh" : "70vh",
            }}
            >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}
            
            <MaterialBox>
                <Grid container spacing={1}>
                    {/* Full Name */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Full Name <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                        <MaterialInput
                            name="fullName"
                            placeholder="eg. Sanjay M"
                            value={formData.fullName}
                            onChange={handleChange}
                            error={formData.fullNameStatus === "error" ? true : false}
                            success={formData.fullNameStatus === "success" ? true : false}
                            disabled={togglePage.view === true ? true : false}
                        />

                        {formData.fullNameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Full Name should be a maximum of 100 characters and contain only alphabets.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>
                    
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Employee ID <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>
                        <MaterialInput
                            name="emp_id"
                            placeholder="eg. KIS100"
                            value={formData.emp_id}
                            onChange={handleChange}
                            error={formData.emp_idStatus === "error" ? true : false}
                            success={formData.emp_idStatus === "success" ? true : false}
                            disabled={togglePage.view === true ? true : false}
                        />

                        {formData.emp_idStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Employee ID should be a maximum of 20 characters.
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>


                    {/* Department */}
                    <Grid size={{ xs: 12, md: 6 }}>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            >
                            Department <span style={{ color: "red" }}>*</span>
                            </MaterialTypography>
                        <MaterialSelect
                            name="department"
                            value={formData.department}                        
                            placeholder="Select Department"
                            onChange={handleChange}
                            options={departmentOptions.map((value) => {
                            return {
                                value: value.id,
                                label: value.departmentName,
                            };
                            })}
                            success={formData.departmentStatus === "success" ? true : false}
                            error={formData.departmentStatus === "error" ? true : false}
                            isDisabled={togglePage.view === true ? true : false}
                            isClearable
                        />
                        {formData.departmentStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Choosing Department is mandatory
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>                    
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        Designation <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>                    
                
                        <MaterialSelect
                            id="designation"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                            options={designationOptions.map((value) => {
                            return {
                                value: value.id,
                                label: value.designation,
                            };
                            })}
                            error={formData.designationStatus === "error" ? true : false}
                            success={formData.designationStatus === "success" ? true : false}
                            isDisabled={togglePage.view === true ? true : false}
                            // isClearable
                        />
                        {formData.designationStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Choosing Designation is mandatory
                                </FormHelperText>
                            </FormControl>
                        )}
                        </Grid>

                    {/* Date of Joining */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Date of Joining <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>

                        <MaterialInput
                            name="doj"
                            type="date"
                            value={formData.doj}
                            onChange={handleChange}
                            error={formData.dojStatus === "error" ? true : false}
                            success={formData.dojStatus === "success" ? true : false}
                            disabled={togglePage.view === true ? true : false}
                        />
                        {formData.dojStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Please enter a valid Date of Joining
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>


                    {/* CTC */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                        CTC <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>

                        <MaterialInput
                            name="ctc"
                            type="number"
                            placeholder="eg. 600000"
                            value={formData.ctc}
                            onChange={handleChange}
                            error={formData.ctcStatus === "error" ? true : false}
                            success={formData.ctcStatus === "success" ? true : false}
                            disabled={togglePage.view === true ? true : false}
                            disableScroll={true}
                        />
                        {formData.ctcStatus === "error" && (
                            <FormControl error>
                            <FormHelperText>
                                CTC should be a positive number
                            </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>

                        {/* Salary Structure */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Salary Structure <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>

                        <MaterialSelect
                            name="salaryStructureId"
                            value={formData.salaryStructureId}                        
                            placeholder="Select Salary Structure"
                            onChange={handleChange}
                            options={salaryStructureOptions.map((value) => {
                            return {
                                value: value.id,
                                label: value.structureName,
                                type: value?.salaryType
                            };
                            })}
                            success={formData.salaryStructureIdStatus === "success" ? true : false}
                            error={formData.salaryStructureIdStatus === "error" ? true : false}
                            isDisabled={togglePage.view === true ? true : false}
                            isClearable
                        />

                        {formData.salaryStructureIdStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Salary Structure is mandatory
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>

                    {/* Basic Percentage */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                        >
                            Basic Percentage <span style={{ color: "red" }}>*</span>
                        </MaterialTypography>

                        <MaterialInput
                            name="basicPercentage"
                            type="number"
                            placeholder="eg. 40"
                            value={formData?.salaryStructureId?.type === "TYPE_TWO" ? "0" : formData.basicPercentage}
                            onChange={handleChange}
                            error={formData.basicPercentageStatus === "error" ? true : false}
                            success={formData.basicPercentageStatus === "success" ? true : false}
                            disabled={togglePage.view === true ? true : false ||
                                formData?.salaryStructureId?.type === "TYPE_TWO"
                            }
                            endAdornment={
                                <InputAdornment position="end">
                                    <MaterialTypography variant="body2" color="textSecondary">
                                        %                    
                                    </MaterialTypography>
                                </InputAdornment>
                            }
                        />

                        {formData.basicPercentageStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                    Basic Percentage should be between 0 and 100
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid>

                </Grid>

            </MaterialBox>            
            {togglePage.view !== true && (
            <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            mt={2}
            >
               <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="error"
                onClick={() => navigate("/appointment-letter")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2}}
                variant="gradient"
                color="success"
                disabled={
                    !checkAllFields() || pageState.state === "submitting"
                }
                onClick={onSubmitForm}
                >
                    {togglePage?.edit ? "Update" : "Create" }
                </MaterialButton> 
            </MaterialBox>
            )}
            </CardContent> 
        </Card>
    </DashboardLayout>
  )
}

export default AppointmentLetterForm